import React, { useContext, useEffect, useState } from "react";
import { BuilderContext } from "../BuilderContext";
import { useHistory } from "react-router-dom";
import ServiceWrapper from "../../../../Services/ServiceWrapper";
import AppSettings from "../../../../Settings/AppSettings";
import AuthManager from "../../../../Common/AuthManager";
import { toast } from "react-toastify";
import { Modal, OverlayTrigger, Popover, PopoverBody } from "react-bootstrap";
import { AppContext } from "../../../../Context/AppContext";
import GMSBorderlessButton from "../../../Common/components/GMSBorderlessButton";
import GMSButton from "../../../Common/components/GMSButton";
import GMSFillButton from "../../../Common/components/GMSFillButton";
import Label from "../../../Common/components/Label";
import "./BuilderStyle.css";
import EyeIcon from "../../../Common/components/EyeIcon";
import BackArrowIcon from "../../../Common/components/BackArrowIcon";
import GlobalFilter from "./GlobalFilter";
import OverlayIcon from "Components/GMS/Rules/Components/OverlayIcon";
import { NAME_INFO, SHORT_NAME_INFO } from "../SmartBuilderConstants";
import BuilderImages from "./FileUpload";
import Utils from "../../../../Common/Utils";

const BuilderHeader = ({
  builderId,
  headerdetails,
  editPage,
  load_Builder_Details,
  builderDetails,
  setUpdatedBuilderDetails,
  setBuilderdetailId,
  edited,
  preview_builder_Details,
  preview_channel,
  mainBuilder,
  setBuilderDetails,
  setBuilderComponentDetails,
}) => {
  const history = useHistory();
  const appData = useContext(AppContext);
  const builderContextData = useContext(BuilderContext);
  const { masterdata, validate_builder, format_builder, globalFilter } =
    builderContextData;
  const api_base_url = AppSettings.GMS_BACKEND_API_URL;
  const [saveButton, setSaveButton] = useState(false);
  const [disableButton, setDisableButton] = useState(false);

  const [builderHeaderDetails, setBuilderHeaderDetails] = useState({
    name: "",
    description: "",
    created_at: "",
    short_name: "",
    is_deleted: false,
    builder_image_detail:"",
  });

  const [showPopup, setShowPopup] = useState(false);
  const [showResetPopup, setShowResetPopup] = useState(false);
  const modalResetClose = () => setShowResetPopup(false);
  const [showResetButton, setShowResetButton] = useState(true);
  const modalClose = () => setShowPopup(false);
  const [clipText, setClipText] = useState(null);
  const [selectedAttributes, setselectedAttributes] = useState([]); 
  const [initialState, setinitialState] = useState({});
  const [initialStateCopy, setinitialStateCopy] = useState(initialState);
  const [builderImages, setBuilderImages] = useState([]);
  const [initialDescriptionAndImages, setInitialDescriptionAndImages] = useState({description: null, images: []})

  function handle_clipbord(text) {
    navigator.clipboard.writeText(text).then(() => setClipText(text));
  }

  useEffect(() => {
    if (headerdetails) {
      const { name, description, created_at, short_name, is_deleted, builder_image_detail } =
        headerdetails;
      let isDelete = is_deleted ? true : false;
      const newData = {
        created_at,
        description,
        name,
        short_name: short_name ?? "",
        is_deleted: isDelete,
        builder_image_detail : builderImages ?? "",
      };
      if (JSON.stringify(newData) !== JSON.stringify(builderHeaderDetails)) {
        setBuilderHeaderDetails(newData);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [headerdetails]);

  useEffect(() => {
    if (editPage) {
      if (builderHeaderDetails.name !== "") {
        updateBuilder();
      }
    } else {
      updateBuilder();
    }

    function updateBuilder() {
      let updatedBuilderHeaderDetail = {
        ...builderHeaderDetails,
        global_filter: globalFilter,
      };
      setBuilderHeaderDetails(updatedBuilderHeaderDetail);
      setUpdatedBuilderDetails((prev) => {
        return { ...prev, builder: updatedBuilderHeaderDetail };
      });
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [globalFilter]);

  const validationOptions = {
    name: {
      required: true,
      minLength: 2,
      maxLength: 60,
      type: "alnum_with_spaces",
    },
    model_number: { required: true },
    version: { required: true },
    min_ad_price: { required: true },
  };

  useEffect(() => {
    const formChanged = has_changes();
    setDisableButton(formChanged);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    initialState,
    initialStateCopy,
    validationOptions,
    appData.builderImagesGlobal,
  ]);

  function has_changes() {
    const validation = Utils.validate(initialState, validationOptions);
    return (
      !validation[0] ||
      (JSON.stringify(initialStateCopy) === JSON.stringify(initialState))
    );
  }


  useEffect(() => {
    if (builderDetails && edited) {
      if (validate_builder(builderDetails) === "" && masterdata) {
        setSaveButton(true);
      } else {
        setSaveButton(false);
      }
    }
  }, [builderDetails, edited]);

  function handle_change(id, value) {
    let updatedBuilderHeaderDetail = { ...builderHeaderDetails, [id]: value };
    setBuilderHeaderDetails(updatedBuilderHeaderDetail);
    setUpdatedBuilderDetails((prev) => {
      return { ...prev, builder: updatedBuilderHeaderDetail };
    });
  }

  const checkPermissionAndPreview = (previewType) => {
    if (appData.pm.checkPermission("gmskbcapps_preview")) {
      if (previewType === "channel") {
        preview_channel();
      } else if (previewType === "builder") {
        preview_builder_Details();
      }
    } else {
      toast.info("You don't have permission to preview the builder");
    }
  };

  const checkPermissionAndSave = () => {
    if (
      appData.pm.checkPermission(
        editPage ? "gmskbcapps_update" : "gmskbcapps_create"
      )
    ) {
      save_builder_Details();
    } else {
      toast.info(
        `You don't have permission to ${
          editPage ? "Save" : "Create"
        } the builder`
      );
    }
  };

  async function save_builder_Details() {
    setDisableButton(true);
    const attributeIds = selectedAttributes.map((attribute) => attribute.value);
    const final_builder = format_builder(builderDetails, attributeIds);
    const allDeleted = final_builder.components.every(
      (component) => component.node.is_deleted === true
    );
    if (allDeleted) {
      setDisableButton(false);
      toast.error(
        "Cannot delete all components. At least one component must remain."
      );
      return;
    }
    toast.info("Saving Builder Details");
    let res;
    const formData = new FormData()
    // append images to formdata if exists
    if (appData.builderImagesGlobal.length > 0) {
      appData.builderImagesGlobal.forEach((file) => {
        formData.append("builder_images", file, file.name);
      });

      formData.append(
        "builder_images_existing_count",
        appData.builderImagesGlobal.length.toString()
      );
    }
    formData.append("data", JSON.stringify(final_builder));
    if (editPage) {
      res = await ServiceWrapper.doPut(
        `${api_base_url}builder/${builderId}`,
        formData,
        null,
        AuthManager.getGmsToken(),
        true
      );
    } else {
      res = await ServiceWrapper.doPost(
        `${api_base_url}builder`,
        formData,
        null,
        AuthManager.getGmsToken(), 
        true
      );
    }

    if (res && !res.errorfound) {
      if (res.data && res.data.done) {
        setDisableButton(false);
        toast.success("Successfully saved Builder.");
        setBuilderdetailId(res.data.id);
        history.push({
          pathname: `/gms/builder`,
          // pathname: `/gms/builder/detail/${res.data.id}`, // to forward to builder detail page
          search: `?version=Draft`,
        });
      } else {
        setDisableButton(false);
        if (res.data && res.data.message) {
          toast.error(res.data.message);
        } else {
          toast.error("Error while saving Builder");
        }
        return false;
      }
    } else {
      setDisableButton(false);
      toast.error("Error while saving Builder");
      return false;
    }
  }
  return (
    <React.Fragment>
      {headerdetails && masterdata && (
        <div className="border-bottom justify-content-between d-flex pb-2 ps-3 pt-2">
          <div className="d-flex align-items-center w-50">
            <BackArrowIcon
              navigateToBuilderListPage={() => {
                if (builderId !== "0") {
                  history.push({
                    pathname: `/gms/builder/detail/${builderId}`,
                  });
                } else {
                  history.push({
                    pathname: `/gms/builder`,
                  });
                }
              }}
            />
            &nbsp;
            <label
              className="col-md-6 align-items-center fs-5 fw-bolder ps-2 pt-1 text-start "
              style={{
                fontFamily: "Noto Sans",
              }}
            >
              {builderId !== "0"
                ? builderHeaderDetails.name ?? "Smart Builder"
                : "Create Smart Builder"}
              &nbsp;
              {showResetButton && (
                <span className="badge  ps-2  pe-2 chip chip-draft">
                  {"Draft"}
                </span>
              )}
              {!showResetButton && (
                <span className="badge  ps-2  pe-2 chip chip-live">
                  {"Live"}
                </span>
              )}
            </label>
          </div>
          {/* <div className="col-md-3 me-4 ms-5"></div> */}
          <div className="col-md-6 w-50 d-flex justify-content-end align-items-center ms-3 pe-2">
            {}
            &nbsp;
            <div className="d-flex align-items-center  preview-button-border tw-gap-1.5">
              <EyeIcon></EyeIcon>
              <GMSBorderlessButton
                name="Preview Builder"
                onClick={() => {
                  checkPermissionAndPreview("channel");
                }}
              />
            </div>
            &nbsp;&nbsp;
            <div className="d-flex align-items-center preview-button-border tw-gap-1.5">
              <EyeIcon></EyeIcon>
              <GMSBorderlessButton
                name="Preview Products"
                onClick={() => {
                  checkPermissionAndPreview("builder");
                }}
              />
            </div>
            <button
              name={"save"}
              onClick={() => checkPermissionAndSave()}
              disabled={!saveButton || !disableButton}
              style={{ padding: "6px", fontSize: "14px" }}
              className="button-fill ms-3 pe-4 ps-4"
            >
              {"Save"}
            </button>
          </div>
        </div>
      )}

      {headerdetails && masterdata && (
        <div
          style={{
            background: "#f2f2f2",
            borderColor: builderHeaderDetails.is_deleted
              ? "#dc3545"
              : "#caccd0",
          }}
          className="builder-border mb-4 pb-2 ps-4 pt-3"
        >
          <div className="">
            <div className="row">
              <div className="col-md-6">
                <div className="tw-flex tw-items-center tw-text-center tw-gap-2">
                  <label className="pb-1 tw-font-semibold">Name</label>
                  <span className="tw-pb-0.5"><OverlayIcon message={NAME_INFO}/></span>
                </div>
                <input
                  type="text"
                  className="form-control col-sm-5 col-md-4 col-xl-5 shadow-none"
                  id="name"
                  style={{
                    fontSize: "0.8rem",
                    color: "black",
                    fontWeight: "500",
                    fontFamily: "Noto Sans",
                    border: `1px solid ${
                      builderHeaderDetails?.name?.length > 0
                        ? "#ced4da"
                        : "#c13e25"
                    }`,
                  }}
                  value={builderHeaderDetails.name}
                  placeholder="Builder Name"
                  aria-describedby="nameHelp"
                  maxLength="60"
                  minLength="2"
                  onChange={(e) => handle_change(e.target.id, e.target.value)}
                />
              </div>
              <div className="col-md-3 ">
                <div className="tw-flex tw-items-center tw-text-center tw-gap-2">
                  <label className="pb-1 tw-font-semibold">Short Name</label>
                  <span className="tw-pb-0.5"><OverlayIcon message={SHORT_NAME_INFO}/></span>
                </div>
                <input
                  type="text"
                  className="form-control col-sm-5 col-md-4 col-xl-5 shadow-none"
                  id="short_name"
                  style={{
                    fontSize: "0.8rem",
                    color: "black",
                    fontWeight: "500",
                    fontFamily: "Noto Sans",
                    border: `1px solid ${
                      builderHeaderDetails?.short_name?.length > 0
                        ? "#ced4da"
                        : "#c13e25"
                    }`,
                  }}
                  value={builderHeaderDetails.short_name}
                  placeholder="Builder Short Name"
                  maxLength="30"
                  minLength="2"
                  aria-describedby="short_nameHelp"
                  onChange={(e) => handle_change(e.target.id, e.target.value)}
                />
              </div>
              <div className="align-self-start col-md-3">
                {editPage && (
                  <>
                    <label
                      className="pb-1 pt-1"
                      style={{
                        fontWeight: "600",
                        fontFamily: "Noto Sans",
                      }}
                    >
                      UID
                    </label>
                    <div className="id">
                      <div
                        className="badge id ps-0"
                        style={{
                          color: "#828282",
                          fontFamily: "Noto Sans",
                        }}
                      >
                        {builderId}
                      </div>
                      &nbsp;
                      <i
                        className={`${
                          clipText === null ? "far" : "fas"
                        } fa-clipboard`}
                        style={{
                          cursor: "pointer",
                          color: "rgb(9, 28, 170)",
                        }}
                        onClick={() => handle_clipbord(builderId)}
                      />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div className="pt-3 ro ">
              <div className="col-md-9 mb-3">
                <label
                  className="pb-1"
                  style={{
                    fontWeight: "600",
                    fontFamily: "Noto Sans",
                  }}
                >
                  Description
                </label>
                <textarea
                  type="text"
                  className="form-control col-md-6 shadow-none"
                  id="description"
                  style={{
                    fontSize: ".8rem",
                    color: "black",
                    fontWeight: "500",
                    fontFamily: "Noto Sans",
                    border: `1px solid #ced4da`,
                  }}
                  placeholder="Builder Description"
                  value={builderHeaderDetails.description}
                  onChange={(e) => handle_change(e.target.id, e.target.value)}
                />
              </div>
            </div>
            <div className="col-md-11 mb-3">
                <label
                  className="pb-1 tw-font-semibold"
                >
                  Builder Image
                </label>
                <BuilderImages 
                  builderId={builderDetails.builder?.uid} 
                  builderImages={builderImages}
                  setBuilderImages={setBuilderImages}
                  setInitialDescriptionAndImages={setInitialDescriptionAndImages}
                />
            </div>
          </div>
        </div>
      )}

      {headerdetails && masterdata && (
        <GlobalFilter
          selectedAttributes={selectedAttributes}
          setselectedAttributes={setselectedAttributes}
          globalFilter={headerdetails?.global_filter ?? []}
          editPage={editPage}
          builderDetails={builderDetails}
        />
      )}

      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showPopup}
        onHide={modalClose}
      >
        <Modal.Body>
          <div className="text-center pt-3 ps-3 pe-3">
            <div className="d-flex">
              <div className="d-inlinealign-items-center">
                <Label
                  message={"Test Builder"}
                  fontWeight={"600"}
                  fontSize={"1.125"}
                />
                &nbsp;
                <span
                  className="badge ps-2 pe-2"
                  style={{
                    fontSize: "0.75rem",
                    backgroundColor: "#F2F2F2",
                    marginBottom: "10px",
                    borderRadius: "34px",
                    color: "#5c5f62",
                    fontFamily: "Noto Sans",
                    fontWeight: "400",
                  }}
                >
                  {"Draft"}
                </span>
                &nbsp;
              </div>
              <Label
                message={"will replace current live version"}
                fontWeight={"600"}
                fontSize={"1.125"}
              />
            </div>

            <div
              className="d-flex mt-3 mb-3 p-2 border-0 border-grey"
              style={{ backgroundColor: "#EBECF0", borderRadius: "4px" }}
            >
              <label style={{ fontSize: ".875rem", fontWeight: "400" }}>
                You can always find the previous version in the same table to
                modify or to promote to live.
              </label>
            </div>
            <Label
              message={"Would you like to proceed?"}
              fontWeight={"400"}
              fontSize={"1"}
            />
            <div className="d-flex justify-content-center mt-2 pb-3">
              <GMSButton name="Cancel" onClick={() => modalClose()} />
              &nbsp; &nbsp;
              <GMSFillButton
                name="Yes, Promote to live"
                onClick={() => {
                  modalClose();
                }}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <Modal
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={showResetPopup}
        onHide={modalResetClose}
      >
        <Modal.Body>
          <div className="text-center pt-3 ps-3 pe-3">
            <div className="d-flex">
              <div className="d-inlinealign-items-center">
                <Label message={"The"} fontWeight={"600"} fontSize={"1.125"} />
                &nbsp;
                <span
                  className="badge ps-2 pe-2"
                  style={{
                    fontSize: "0.75rem",
                    backgroundColor: "#F2F2F2",
                    marginBottom: "10px",
                    borderRadius: "34px",
                    color: "#5c5f62",
                    fontFamily: "Noto Sans",
                    fontWeight: "400",
                  }}
                >
                  {"Draft"}
                </span>
                &nbsp;
              </div>
              <Label
                message={"builder will replace current live version"}
                fontWeight={"600"}
                fontSize={"1.125"}
              />
            </div>

            <div
              className="d-flex mt-3 mb-3 p-2 border-0 border-grey"
              style={{ backgroundColor: "#EBECF0", borderRadius: "4px" }}
            >
              <label style={{ fontSize: ".875rem", fontWeight: "400" }}>
                You may loose all recent changes on this builder & data on live
                builder will be copied.
              </label>
            </div>
            <Label
              message={"Would you like to proceed?"}
              fontWeight={"400"}
              fontSize={"1"}
            />
            <div className="d-flex justify-content-center mt-2 pb-3">
              <GMSButton name="Cancel" onClick={() => modalResetClose()} />
              &nbsp; &nbsp;
              <GMSFillButton
                name="Yes, Reset"
                onClick={() => {
                  setShowResetButton(false);
                  setBuilderDetails(mainBuilder?.live);
                  setBuilderComponentDetails(mainBuilder?.live?.components);
                  modalResetClose();
                }}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </React.Fragment>
  );
};
export default BuilderHeader;
